import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './scenes/login';
import Dashboard from './scenes/dashboard';
import Despesas from './scenes/despesas';
import Horas from './scenes/horas';
import Clientes from './scenes/clientes';
import Colaboradores from './scenes/colaboradores';
import RegistarColaborador from './scenes/colaboradores/registar';
import DetalhesColaborador from './scenes/colaboradores/detalhes';
import EditColaborador from './scenes/colaboradores/editar';
import RegisterCliente from './scenes/clientes/registar';
import DetalhesProjeto from './scenes/clientes/detalhes';
import EditCliente from './scenes/clientes/editar';
import RegistarMapaDespesas from './scenes/despesas/registar';
import DetalhesDespesa from './scenes/despesas/detalhes';
import EditDespesa from './scenes/despesas/editar';
import RegistarHoras from './scenes/horas/registar';
import DetalhesHoras from './scenes/horas/detalhes';
import EditHoras from './scenes/horas/editar';
import Bar from './scenes/bar/index.jsx';
import Sidebar from './scenes/global/Sidebar.jsx';
import Topbar from './scenes/global/Topbar.jsx';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { ColorModeContext, useMode } from "./theme";
import './App.css'; // Certifique-se de que o CSS está importado corretamente

const App = () => {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const location = useLocation();

  const isLoginRoute = location.pathname === '/login';

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {!isLoginRoute && (
            <AuthProvider>
              <Sidebar isSidebar={isSidebar} />
            </AuthProvider>
          )}
          <div className={`main-content ${isLoginRoute ? 'full-width' : ''}`}>
            {!isLoginRoute && <Topbar setIsSidebar={setIsSidebar} />}
            <AuthProvider>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/despesas" element={<ProtectedRoute><Despesas /></ProtectedRoute>} />
                <Route path="/despesas/registar" element={<ProtectedRoute><RegistarMapaDespesas /></ProtectedRoute>} />
                <Route path="/despesas/detalhes/:id" element={<ProtectedRoute><DetalhesDespesa /></ProtectedRoute>} />
                <Route path="/despesas/editar/:id" element={<ProtectedRoute><EditDespesa /></ProtectedRoute>} />
                <Route path="/horas" element={<ProtectedRoute><Horas /></ProtectedRoute>} />
                <Route path="/horas/registar" element={<ProtectedRoute><RegistarHoras /></ProtectedRoute>} />
                <Route path="/horas/detalhes/:id" element={<ProtectedRoute><DetalhesHoras /></ProtectedRoute>} />
                <Route path="/horas/editar/:id" element={<ProtectedRoute><EditHoras /></ProtectedRoute>} />

                <Route
                  path="/colaboradores/registar"
                  element={
                    <ProtectedRoute requireRole="ADMIN">
                      <RegistarColaborador />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/colaboradores"
                  element={
                    <ProtectedRoute requireRole="ADMIN">
                      <Colaboradores />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/colaboradores/detalhes/:id"
                  element={
                    <ProtectedRoute requireRole="ADMIN">
                      <DetalhesColaborador />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/colaboradores/editar/:id"
                  element={
                    <ProtectedRoute requireRole="ADMIN">
                      <EditColaborador />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/clientes/registar"
                  element={
                    <ProtectedRoute requireRole="ADMIN">
                      <RegisterCliente />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/clientes"
                  element={
                    <ProtectedRoute requireRole="ADMIN">
                      <Clientes />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/clientes/detalhes/:id"
                  element={
                    <ProtectedRoute requireRole="ADMIN">
                      <DetalhesProjeto />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/clientes/editar/:id"
                  element={
                    <ProtectedRoute requireRole="ADMIN">
                      <EditCliente />
                    </ProtectedRoute>
                  }
                />                
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </AuthProvider>
          </div>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
